import { render, staticRenderFns } from "./CroppingBlock.vue?vue&type=template&id=ac8e8b54&scoped=true&"
import script from "./CroppingBlock.vue?vue&type=script&lang=js&"
export * from "./CroppingBlock.vue?vue&type=script&lang=js&"
import style1 from "./CroppingBlock.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac8e8b54",
  null
  
)

export default component.exports